/**
 * The click to accept undertaking that stands between a reviewer and Tier 2.
 *
 * A native dialog, so focus containment, Escape and the backdrop come from the
 * browser rather than from us. Accepting posts the version the API told us to
 * accept; the portal never picks a version of its own.
 */

import { useEffect, useRef } from 'react';

import { NDA_ACCEPT, NDA_CANCEL, NDA_HEADING, NDA_RECORD_NOTICE } from '../copy';
import { NDA_CLOSING, NDA_INTRO, NDA_TERMS } from '../nda';

interface NdaModalProps {
  open: boolean;
  ndaVersion: string;
  busy: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

export function NdaModal({ open, ndaVersion, busy, onAccept, onCancel }: NdaModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) {
      dialog.showModal();
    } else if (!open && dialog.open) {
      dialog.close();
    }
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      className="nda"
      aria-labelledby="nda-heading"
      onCancel={(event) => {
        event.preventDefault();
        if (busy) return;
        onCancel();
      }}
    >
      <h2 id="nda-heading">{NDA_HEADING}</h2>
      <p>{NDA_INTRO}</p>
      <ul className="terms">
        {NDA_TERMS.map((term) => (
          <li key={term}>{term}</li>
        ))}
      </ul>
      <p>{NDA_CLOSING}</p>
      <p className="nda-meta">
        {NDA_RECORD_NOTICE} Version {ndaVersion}.
      </p>
      <div className="nda-actions">
        <button type="button" className="button-secondary" onClick={onCancel} disabled={busy}>
          {NDA_CANCEL}
        </button>
        <button type="button" className="button-primary" onClick={onAccept} disabled={busy}>
          {NDA_ACCEPT}
        </button>
      </div>
    </dialog>
  );
}
